import React from "react";

const ArrowIcon = (props) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6 11L12.5 14L19 11"
        stroke="#707881"
        strokeOpacity="0.99"
        strokeWidth="2"
      />
    </svg>
  );
};

export { ArrowIcon };
